import(/* webpackMode: "eager", webpackExports: ["TournamentClientWrapper"] */ "/app/apps/pickleball/src/modules/players/v2/tabs/tournaments/TournamentsClientWrapper.tsx");
